import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { bodyOwnerStepsData } from '@/modules/adjusterReportModules/Insurer-information/data/bodyOwnerStepsData';
import { PropsWithChildren } from 'react';

import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout
      title={'بیمه گذار / مالک'}
      header="closeHeader"
      hasBottomPadding
    >
      <BodyOwnerInfo>{children}</BodyOwnerInfo>
    </MainLayout>
  );
};
const BodyOwnerInfo = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={bodyOwnerStepsData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">{children}</Box>
      <ImagesFabMainModal state="body" />
    </>
  );
};
